<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="访问来源">
              <j-dict-select-tag placeholder="请选择访问来源" v-model="queryParam.visitSource" dictCode="visit_source"  :is-choose-first="true" @chooseFirst="handleChooseFirst" />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="花色">
              <a-input placeholder="请输入花色" v-model="queryParam.jpFlowerColor"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="访问省">
              <a-input placeholder="请输入访问省" v-model="queryParam.province"></a-input>
            </a-form-item>
          </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="访问市">
                <a-input placeholder="请输入访问市" v-model="queryParam.city"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="访问区">
                <a-input placeholder="请输入访问区" v-model="queryParam.county"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="12" :lg="12" :md="14" :sm="24">
            <a-form-item label="访问日期">
              <a-range-picker show-time format="YYYY-MM-DD HH:mm:ss" @change="getNewDate" style="margin-right: 2%" />
              
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('金牌石浏览记录表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

      </a-table>
    </div>

    <goldStoneJpglistsVisitLog-modal ref="modalForm" @ok="modalFormOk"></goldStoneJpglistsVisitLog-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import GoldStoneJpglistsVisitLogModal from './modules/GoldStoneJpglistsVisitLogModal'
  import moment from 'moment'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  export default {
    name: "GoldStoneJpglistsVisitLogList",
    mixins:[JeecgListMixin],
    components: {
      GoldStoneJpglistsVisitLogModal,
      JDictSelectTag
    },
    data () {
      return {
        description: '金牌石浏览记录表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'花色',
            align:"center",
            dataIndex: 'jpFlowerColor'
          },
          {
            title:'系列名称',
            align:"center",
            dataIndex: 'goldenStoneStoneseriesName'
          },
          {
            title:'产品名称',
            align:"center",
            dataIndex: 'goldenStoneStonetypeName'
          },
          {
            title:'访问省',
            align:"center",
            dataIndex: 'province'
          },
          {
            title:'访问市',
            align:"center",
            dataIndex: 'city'
          },
          {
            title:'访问区',
            align:"center",
            dataIndex: 'county'
          },
          {
            title:'访问时间',
            align:"center",
            dataIndex: 'createDate'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/goldenstone.base/goldStoneJpglistsVisitLog/list",
          delete: "/goldenstone.base/goldStoneJpglistsVisitLog/delete",
          deleteBatch: "/goldenstone.base/goldStoneJpglistsVisitLog/deleteBatch",
          exportXlsUrl: "/goldenstone.base/goldStoneJpglistsVisitLog/exportXls",
          importExcelUrl: "goldenstone.base/goldStoneJpglistsVisitLog/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){},
      //日期组件
      moment,
      getNewDate(dates, dateStrings) {
        this.queryParam.createDate_begin = dateStrings[0]
        this.queryParam.createDate_end = dateStrings[1]
      },
      handleChooseFirst(){
        this.searchQuery();
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>